import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {ButtonGroup, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(ButtonGroup, {
        'children': [
            _$cc(Button, {
                'ev-click': this.showCloseDelay,
                'children': '10s后关闭'
            }),
            _$cc(Button, {
                'ev-click': this.showStick,
                'children': '不会自动关闭'
            })
        ]
    });
};